import type { BulkImportBrand, BulkUserType } from '../types';
import { getBulkUserTypeLabel } from '../utils';

interface BulkImportSummaryProps {
  userType: BulkUserType;
  brands: BulkImportBrand[];
  totalRows: number;
  validRows: number;
  invalidRows: number;
  removedRows: number;
  sendableRows: number;
}

export function BulkImportSummary({
  userType,
  brands,
  totalRows,
  validRows,
  invalidRows,
  removedRows,
  sendableRows,
}: BulkImportSummaryProps) {
  return (
    <div className="space-y-3 rounded-md border border-gray-200 bg-gray-50 p-4">
      <dl className="grid grid-cols-1 gap-3 text-sm sm:grid-cols-2">
        <div>
          <dt className="text-muted-foreground">Tipo de usuário</dt>
          <dd className="font-medium text-gray-900">{getBulkUserTypeLabel(userType)}</dd>
        </div>
        <div>
          <dt className="text-muted-foreground">Marcas</dt>
          <dd className="font-medium text-gray-900">
            {brands.length > 0 ? brands.map((brand) => brand.name).join(', ') : 'Nenhuma marca selecionada'}
          </dd>
        </div>
        <div>
          <dt className="text-muted-foreground">Total</dt>
          <dd className="font-medium text-gray-900">{totalRows}</dd>
        </div>
        <div>
          <dt className="text-muted-foreground">Válidos</dt>
          <dd className="font-medium text-gray-900">{validRows}</dd>
        </div>
        <div>
          <dt className="text-muted-foreground">Com erro</dt>
          <dd className="font-medium text-gray-900">{invalidRows}</dd>
        </div>
        <div>
          <dt className="text-muted-foreground">Removidos</dt>
          <dd className="font-medium text-gray-900">{removedRows}</dd>
        </div>
        <div>
          <dt className="text-muted-foreground">Selecionados para importação</dt>
          <dd className="font-medium text-gray-900">{sendableRows}</dd>
        </div>
      </dl>
      <p className="text-sm text-gray-700">
        {sendableRows} usuários serão enviados para cadastro.
      </p>
    </div>
  );
}
